import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import TopLogo from "../../components/layout/TopLogo";
import QRCodeItem from "../../components/general/QRCodeItem";
import SecondaryButton from "../../components/button/SecondaryButton";
import { useSelector, useDispatch } from 'react-redux';
import { setMember } from "../../features/MemberSlice";
import { SearchQrCode, CreateQrCode } from "../../services/Coupon";
import { useLiff } from "react-liff";
import helper from "../../functions/helper";
import Barcode from 'react-barcode';



export default function MemberCouponQrCode() {
    // api state
    const { liff } = useLiff();
    const lineId = liff.getDecodedIDToken().sub;
    let [QRCodeValue, setQRCodeValue] = useState('');
    const store = useSelector((state) => state.member)
    let [qrCode, setQrCode] = useState(store['qrCode']);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [minutes, setMinutes] = useState(null);
    const [seconds, setSeconds] = useState(null);
    const [couponDetail, setCouponDetail] = useState(null);
    const [isUsed, setIsUsed] = useState(false);

    useEffect(() => {
        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    // clearInterval(myInterval)
                    navigate('/member-coupon')
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }

        }, 1000)
        return () => {
            clearInterval(myInterval);
        };
    }, [seconds, minutes]);


    useEffect(() => {
        if (qrCode) {
            getSearchQrCode()
        } else {
            postCreateQrCode()
        }
    }, [qrCode]);

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setMember(tmpObj));
    }

    useEffect(() => {
        if (!isUsed) {
            let myInterval = setInterval(() => {
                getSearchCheckQrCode()
            }, 5000)
            return () => {
                clearInterval(myInterval);
            };
        }
    }, [isUsed, qrCode]);

    async function getSearchQrCode() {
        return await SearchQrCode({ data: { qrCode: qrCode, memberId: store['memberId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setIsUsed(response.data.body.isUsed)
                    const expireDate = response.data.body.expireDate
                    let totalSec = dayjs(expireDate).diff(new Date(), 'second')
                    const min = parseInt(totalSec / 60);
                    const sec = parseInt(totalSec % 60);
                    if (min === 15 && sec > 0) {
                        setMinutes(min)
                        setSeconds(0)
                    } else {
                        setMinutes(min)
                        setSeconds(sec)
                    }
                    setCouponDetail(response.data.body.coupon)
                    setQRCodeValue(response.data.body.qrCode)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function postCreateQrCode() {
        return await CreateQrCode({ data: { lineId: lineId, couponId: store['couponId'], memberId: store['memberId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setQrCode(response.data.body.qrCode)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function getSearchCheckQrCode() {
        return await SearchQrCode({ data: { qrCode: qrCode, memberId: store['memberId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    setIsUsed(response.data.body.isUsed)
                    let data = response.data.body
                    if (response.data.body.isUsed) {
                        if (data.coupon.discountType === 'Fix') {
                            data.coupon.discountText = `฿${helper.numberWithCommas(data.coupon.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(data.coupon.min)}`
                        } else {
                            data.coupon.discountText = `${helper.numberWithCommas(data.coupon.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(data.coupon.min)}`
                        }
                        fnSetData('couponDetail', data)
                        navigate('/member-coupon-success')
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    return (
        <div id="generate-qr-code-page" className="page-f-screen">
            <TopLogo />
            {couponDetail && <div id="generate-qr-code" style={{ background: "#005AAA" }} className="gradientBg mt-[0px] pt-[24px] pb-[36px] px-[13px] flex-1">
                <div className="text-white text-center text-[20px] my-[15px]">
                    คูปองถูกใช้ไปแล้ว {couponDetail.usedAmount}/{couponDetail.amount}
                </div>

                <div className="overflow-y-auto px-[20px]">
                    {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                    <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                        <div className="text-center">
                            <p className="text-blue text-[24px]">{couponDetail.name}</p>
                            <p className="text-darkGray text-[20px]">ใช้คูปองได้ถึง {dayjs(couponDetail.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                        </div>

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                        <div className="text-center">
                            <p className="text-blue font-bold text-[34px] leading-[20px]">Scan QR เพื่อรับสิทธิ์</p>
                        </div>

                        <div className="QR CODE flex justify-center">
                            <div className="p-[12px]">
                                <QRCodeItem value={QRCodeValue} style={{ width: "70%", height: "70%" }} />
                            </div>
                        </div>

                        <div className="justify-center mx-auto w-[80%]" style={{ backgroundColor: "#B2B2B245", borderRadius: "10px" }}>
                            <div className="p-[12px] text-center">
                                <p className="text-[20px] leading-[18px]">Coupon Code</p>
                                <p className="font-bold text-[30px] leading-[20px]">{QRCodeValue}</p>
                            </div>
                        </div>

                        <div className="flex justify-center">
                            <div className="px-[12px]">
                                <Barcode className="w-[100%]" value={QRCodeValue} displayValue="false" width="2" />
                            </div>
                        </div>



                        <div className="text-center">
                            <p className="text-red text-[16px]">กรุณาให้พนักงานแสกนคูปองที่หน้าร้านเท่านั้น</p>
                        </div>

                        <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                        <div className="grid grid-cols-3 px-[40px]">
                            <div style={{ borderRight: "1px #E9E9E9 solid" }}>
                                <div className="text-center" >
                                    <p className="text-red text-[16px]">หมดอายุใน</p>
                                </div>
                            </div>
                            <div style={{ borderRight: "1px #E9E9E9 solid" }}>
                                <div className="text-center flex w-fit mx-auto">
                                    <p className="text-red font-bold leading-[16px] text-[34px]"> {minutes}  </p>&nbsp;&nbsp;<p className="text-[16px]">  นาที</p>
                                </div>
                            </div>
                            <div>
                                <div className="text-center flex w-fit mx-auto">
                                    <p className="text-red font-bold leading-[16px] text-[34px]">{seconds < 10 ? `0${seconds}` : seconds}  </p>&nbsp;&nbsp;<p className="text-[16px]">วินาที</p>
                                </div>
                            </div>

                        </div>
                        <hr className="border-b-1px border-lightGray w-full mt-[10px]" />

                        <div className="text-center my-4 px-[20px]">
                            <SecondaryButton variant="outlined" className="w-full" onClick={() => navigate("/member-coupon")}>
                                ยกเลิก
                            </SecondaryButton>
                        </div>
                    </div>

                </div>
            </div>
            }
        </div>
    );
}
